/* eslint-disable no-loop-func */
import React from "react";
import { Button, Modal, ModalBody, Row } from "reactstrap";
import Animate from "../Animate";
import Fireworks from "../ResultsAndEffects/fireworks";
import ExerciseKey from "../ExerciseKey";
import styles from "../FooterModal/styles.module.css";

export default function DragAndDrop({ props, exerciseKey }) {
  // Nếu chỉ dùng riêng drap and drop thì ẩn 2 nút button làm lại và nộp bài trong footer đi
  // Nếu dùng chung với component khác thì ẩn 2 nút button làm lại và nộp bài của component này (xem trang 7 câu 3)

  const [clicked, setClicked] = React.useState(false);
  const [target, setTarget] = React.useState(undefined);
  const [disable, setDisable] = React.useState(false);
  const hideBtnFooter = props?.[0]?.hideBtnFooter || false;

  const [openModal, setOpenModal] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [countStudentAnswers, setCountStudentAnswers] = React.useState(0); // đếm số lần trả lời sai. Nếu >=3 hiển thị button key

  const [finalAnswers, setFinalAnswers] = React.useState([]);
  const [star, setStar] = React.useState(0);
  const dragImage = props?.[0].dragImage || false; // true = kéo thả hình ảnh, false = kéo thả text

  const imageHeight = React.useRef(0);
  const imageWidth = React.useRef(0);

  let defaultPostion = props?.[0]?.defaultPostion || [];
  let answers = props?.[0]?.answers || [];
  let decreaseLeft = props?.[0]?.decreaseLeft || 0;
  let decreaseTop = props?.[0]?.decreaseTop || 0;
  let result = [];

  React.useEffect(() => {
    let startX = 0;
    let startY = 0;
    let lastX = 0;
    let lastY = 0;

    let dropContainer = document.getElementById("form-container"); // lấy từ T6 From id

    let getTarget = document.querySelectorAll("#drag"); // lấy từ view page xxx

    // lấy hình cần kéo thả trong danh sách
    for (let i = 0; i < getTarget.length; i++) {
      getTarget[i].style.cursor = "pointer";
      getTarget[i].addEventListener("mousedown", (e) => {
        let target = getTarget[i];
        onMouseDown(e, target);
      });
    }

    function onMouseDown(e, target) {
      setTarget(target);
      setClicked(true);
      startX = e.clientX;
      startY = e.clientY;
      imageHeight.current = target.offsetHeight;
      imageWidth.current = target.offsetWidth;
    }
    // end lấy hình cần kéo thả

    function onMouseUp(e) {
      setClicked(false);
      lastX = target.style.left;
      lastY = target.style.top;

      getResult();
    }

    function onMouseMove(e) {
      e.preventDefault();

      if (!clicked) return;

      if (lastX === 0) {
        lastX = dropContainer.offsetLeft;
      }

      if (lastY === 0) {
        lastY = dropContainer.offsetTop;
      }

      target.style.left =
        e.clientX +
        startX -
        lastX -
        imageWidth.current / 2 +
        decreaseLeft +
        "px";

      target.style.top =
        e.clientY + startY - lastY - imageHeight.current + decreaseTop + "px";
    }
    if (target !== undefined) {
      dropContainer.addEventListener("mouseup", onMouseUp);
      dropContainer.addEventListener("mousemove", onMouseMove);
    }

    return () => {
      dropContainer.removeEventListener("mousemouse", onMouseMove);
      dropContainer.removeEventListener("mouseup", onMouseUp);
      if (target !== undefined) {
        target.removeEventListener("mousedown", onMouseDown);
      }
    };
  });

  function getResult() {
    let getTarget = document.querySelectorAll("#drag"); // lấy từ view page xxx
    let finalResult = []; // nếu length >0 thì đoạn văn chưa di chuyển

    getTarget.forEach((item) => {
      let left = item.style.left.replace("px", "");
      let top = item.style.top.replace("px", "");
      result.push({ left: Number(left), top: Number(top) });
      setFinalAnswers(result);
    });

    // defaultPostion.forEach((items, index) => {
    //   let checkPosition = result.find(
    //     (x) => x.left === items.left && x.top === items.top
    //   ); // kiểm tra vị trí đoạn văn .Nếu chưa kéo thả thì disable nộp bài
    //   if (checkPosition !== undefined) finalResult.push(checkPosition);

    //   if (finalResult.length > 0) {
    //     setDisable(true);
    //   } else {
    //     setDisable(false);
    //   }
    // });
  }

  // click nut nộp bài
  function checkResult() {
    let count = 0;
    let getTarget = document.querySelectorAll("#drag"); // lấy từ view page xxx
    let tickImage = document.querySelectorAll("#tick-image");
    let errorImage = document.querySelectorAll("#error-image");

    // không di chuyển hình click nút nộp bài
    if (!finalAnswers.length) {
      setOpenModal(true);
      setTimeout(() => {
        setOpenModal(false);
      }, 3000);
      setCountStudentAnswers((prev) => prev + 1);
      for (let i = 0; i < errorImage.length; i++) {
        errorImage[i].style.display = "block";
      }
      return;
    }
    // end không di chuyển hình click nút nộp bài

    answers.forEach((items, index) => {
      if (
        items.minLeft <= finalAnswers[index].left &&
        finalAnswers[index].left <= items.maxLeft &&
        items.minTop <= finalAnswers[index].top &&
        finalAnswers[index].top <= items.maxTop
      ) {
        count++;
        if (dragImage) {
          tickImage[index].style.display = "block";
          errorImage[index].style.display = "none";
        } else {
          //  đổi màu xanh khi trả lời đúng

          getTarget[index].style.border = "1px solid green";
        }
      } else {
        if (dragImage) {
          errorImage[index].style.display = "block";
          tickImage[index].style.display = "none";
        } else {
          //  đổi màu đỏ khi trả lời sai

          getTarget[index].style.border = "1px solid red";
        }
      }
    });
    let correctAnswers = (count / answers.length) * 100;
    setStar(correctAnswers / 20);
    correctAnswers > 80 ? setCountStudentAnswers(pre => pre + 2) : setCountStudentAnswers(pre => pre + 1)
    setOpenModal(true);
    setTimeout(() => {
      setOpenModal(false);
    }, 3000);
  }

  function handleKeyButton() {
    setVisible(!visible);
  }

  // click nút làm lại
  function handleReset() {
    setStar(0); // reset câu trả lời
    let getTarget = document.querySelectorAll("#drag"); // lấy từ view page xxx
    let tickImage = document.querySelectorAll("#tick-image");
    let errorImage = document.querySelectorAll("#error-image");

    // reset về vị trí ban đầu + reset color
    getTarget.forEach((items, index) => {
      items.style.left = defaultPostion[index].left + "px";
      items.style.top = defaultPostion[index].top + "px";
      items.style.color = "#262626";
    });

    // hide tick and error image
    if (tickImage && tickImage.length > 0) {
      for (let i = 0; i < tickImage.length; i++) {
        tickImage[i].style.display = "none";
        errorImage[i].style.display = "none";
      }
    }
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          bottom: "21px",
          right: "100px",
        }}
      >
        {/* =============button làm lại===================== */}

        <Button
          type="button"
          color="danger"
          disabled={disable}
          onClick={() => handleReset()}
          hidden={hideBtnFooter}
        >
          làm lại
        </Button>

        {/* =============button Nộp bài===================== */}

        <Button
          type="button"
          color="danger"
          disabled={disable}
          onClick={() => checkResult()}
          hidden={hideBtnFooter}
        >
          Nộp bài
        </Button>
      </div>

      {/* ===========key button ============================*/}
      {countStudentAnswers >= 2 && (
        <div
          style={{
            position: "fixed",
            bottom: "21px",
            left: "20px",
            zIndex: 9999,
          }}
        >
          <Button
            color="info"
            type="button"
            className="btn-icon btn-2"
            onClick={handleKeyButton}
          >
            <span className="btn-inner--icon">
              <i className="fas fa-key"></i>
            </span>
          </Button>
        </div>
      )}

      {/* ==============Modal ngôi sao===================================== */}
      <Modal centered isOpen={openModal} style={{ maxWidth: 640 }}>
        <ModalBody>
          {/* {renderContent} */}
          {star >= 1 && <Fireworks />}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: 240,
            }}
          >
            <Animate resultString={star} />
          </div>
        </ModalBody>
      </Modal>

      {/* ==========Hình ảnh đáp án======================== */}
      <ExerciseKey
        exerciseKey={exerciseKey}
        visible={visible}
        onClose={() => setVisible(false)}
      />
    </>
  );
}
